import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import {
  getActiveSlots,
  getStorePickupData,
  getStorePickupSlotsFromTime,
  getStorePickupStartAndEndDate,
  isToday,
} from "../../helper";
import { getCategoriesView } from "../../components/helper";
import "./styles.scss";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
export default function StorePickupOptions(props) {
  const {
    selectedStorePickupSlot,
    setSelectedStorePickupSlot,
    selectedStorePickupDate,
    setSelectedStorePickupDate,
  } = props;
  const [storePickupCounter, setStorePickupCounter] = useState(null);
  const [storePickupSlots, setStorePickupSlots] = useState(null);
  const [minDate, setStartDate] = useState(new Date());
  const [maxDate, setEndDate] = useState(new Date());
  const [activeStorePickupSlots, setActiveStorePickupSlots] = useState(false);
  const selectedDate =
    selectedStorePickupDate ||
    `${new Date().getDate()}/${new Date().getMonth()}/${new Date().getFullYear()}`;

  const getStorePickupView = (_, startIndex, endIndex, handleOnClick) => {
    let retval = [];
    for (let i = startIndex; i <= endIndex; i++) {
      retval.push(
        <Form.Check
          type="radio"
          label={activeStorePickupSlots[i]}
          checked={selectedStorePickupSlot === activeStorePickupSlots[i]}
          onChange={() => setSelectedStorePickupSlot(activeStorePickupSlots[i])}
        />
      );
    }
    return retval;
  };

  useEffect(() => {
    if (storePickupCounter === null || storePickupSlots === null) {
      getStorePickupData().then((result) => {
        setStorePickupCounter(result.counter);
        if (result.counter >= 0) {
          const { startDate, endDate } = getStorePickupStartAndEndDate(
            result.counter
          );
          const activeStorePickupSlots = getActiveSlots(result.time_slots);
          setStorePickupSlots(activeStorePickupSlots);
          if (isToday(startDate) && activeStorePickupSlots) {
            const todayStorePickupSlots = getStorePickupSlotsFromTime(
              startDate.getHours(),
              activeStorePickupSlots
            );
            setActiveStorePickupSlots(todayStorePickupSlots);
          } else {
            setActiveStorePickupSlots(activeStorePickupSlots);
          }
          setSelectedStorePickupDate(
            `${startDate.getDate()}/${startDate.getMonth()}/${startDate.getFullYear()}`
          );
          setStartDate(startDate);
          setEndDate(endDate);
        }
      });
    }
  });
  return storePickupSlots ? (
    <div className="store-pickup-slots text-center">
      <div className="p-1">
        Store Pickup Date
        <DatePicker
          className="mt-3"
          selected={new Date().setDate(selectedDate.split("/")[0])}
          withPortal
          dateFormat="dd/MM/yyyy"
          minDate={minDate}
          maxDate={maxDate}
          onChange={async (date) => {
            if (isToday(date) && storePickupSlots) {
              const todayStorePickupSlots = getStorePickupSlotsFromTime(
                date.getHours(),
                storePickupSlots
              );
              setActiveStorePickupSlots(todayStorePickupSlots);
            } else {
              setActiveStorePickupSlots(storePickupSlots);
            }
            setSelectedStorePickupDate(
              `${date.getDate()}/${date.getMonth()}/${date.getFullYear()}`
            );
          }}
        />
      </div>
      <p className="text-center p-1 mt-2 mb-2">Store Pickup Slot</p>
      {getCategoriesView(activeStorePickupSlots, getStorePickupView, null, {
        xs: 2,
        sm: 2,
        md: 4,
        lg: 4,
      })}
    </div>
  ) : (
    <div className="text-center mt-3">
      {storePickupSlots && storePickupSlots.length === 0
        ? "Store Pickup is currently disabled. Please check back later"
        : "Fetching Store Pickup Slots"}
    </div>
  );
}
